// CustomerContext.js
import React, { createContext, useContext, useState } from "react";
import { useAuth } from "./AuthContext";
import { useFetchOncePerUser } from "../hooks/useFetchOncePerUser";
import {
  getAllCustomers,
  createCustomer,
  updateCustomer as updateCustomerService,
  deleteCustomer as deleteCustomerService,
} from "../api/services/customerService";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customers, setCustomers] = useState([]);
  const { user } = useAuth();

  async function fetchCustomers() {
    try {
      const data = await getAllCustomers();
      setCustomers(data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  }
  useFetchOncePerUser(user, fetchCustomers);

  const addCustomer = async (customerData) => {
    try {
      const data = await createCustomer(customerData);
      setCustomers([...customers, data]);
      return data;
    } catch (error) {
      console.error("Error adding customer:", error);
      throw error;
    }
  };

  const updateCustomer = async (customerId, updatedData) => {
    try {
      const data = await updateCustomerService(customerId, updatedData);
      setCustomers(
        customers.map((customer) =>
          customer._id === customerId ? data : customer
        )
      );
      return data;
    } catch (error) {
      console.error("Error updating customer:", error);
      throw error;
    }
  };

  const deleteCustomer = async (customerId) => {
    try {
      await deleteCustomerService(customerId);
      setCustomers(customers.filter((customer) => customer._id !== customerId));
    } catch (error) {
      console.error("Error deleting customer:", error);
      throw error;
    }
  };

  return (
    <CustomerContext.Provider
      value={{
        customers,
        addCustomer,
        updateCustomer,
        deleteCustomer,
        fetchCustomers,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error("useCustomer must be used within a CustomerProvider");
  }
  return context;
};
